import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'tenders/matcheswithid',
    template: '<div></div>'
})
export class MatchesWithIdComponent implements OnInit {
    private readonly fromUrlKey = 'matchingTenderId';
    routeParamsSub: Subscription;

    constructor(private readonly router: Router, private readonly route: ActivatedRoute) {
        
    }

    ngOnInit() {
        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            localStorage.setItem(this.fromUrlKey, params['id']);

            this.router.navigateByUrl('/tenders/mymatches');
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tenders/matches.with.id.component.ts